<script lang="ts">
	import { Input } from "flowbite-svelte";
	import { stringValueFromDataTypeValue, type DataTypeInputProps } from "#lib/components/flow/editor/data-types/inputs/dataTypeInput.js";

	let { value = $bindable(), defaultValue, disabled, invalid, required, type = "text", autocomplete, inputmode, oninput, onchange, onblur, oninvalid }: DataTypeInputProps = $props();

	let fallbackValue = $derived(type === "date" ? stringValueFromDataTypeValue(defaultValue) : "");
</script>

<Input bind:value={() => stringValueFromDataTypeValue(value) ?? fallbackValue, v => (value = v)} placeholder={stringValueFromDataTypeValue(defaultValue)} {type} size="md" {autocomplete} {inputmode} {disabled} {required} color={invalid ? "red" : undefined} on:input={e => oninput?.(e)} on:change={e => onchange?.(e)} on:blur={e => onblur?.(e)} on:invalid={e => oninvalid?.(e)} />
